// src/utils/translations.js
export const t = (language, key) => {
  const translations = {
    // Common
    "loading": { pt: "Carregando...", en: "Loading..." },
    "save": { pt: "Salvar", en: "Save" },
    "cancel": { pt: "Cancelar", en: "Cancel" },
    "delete": { pt: "Excluir", en: "Delete" },
    "edit": { pt: "Editar", en: "Edit" },
    "view": { pt: "Ver", en: "View" },
    "back": { pt: "Voltar", en: "Back" },
    "close": { pt: "Fechar", en: "Close" },

    // Health & Safety Page
    "healthSafety": { pt: "Saúde e Segurança", en: "Health & Safety" },
    "healthSafetySubtitle": { pt: "Saúde e Segurança no Trabalho - Documentos e Treinamentos", en: "Workplace Health & Safety - Documents and Training" },
    "documents": { pt: "Documentos", en: "Documents" },
    "training": { pt: "Treinamento", en: "Training" },
    "noDocuments": { pt: "Nenhum documento disponível no momento.", en: "No documents available at the moment." },
    "signed": { pt: "Assinado", en: "Signed" },
    "pending": { pt: "Pendente", en: "Pending" },
    "version": { pt: "Versão", en: "Version" },
    "language": { pt: "Idioma", en: "Language" },
    "portuguese": { pt: "Português", en: "Portuguese" },
    "english": { pt: "Inglês", en: "English" },
    "signedOn": { pt: "Assinado em", en: "Signed on" },
    "viewDocument": { pt: "Ver Documento", en: "View Document" },
    "openAndSign": { pt: "Abrir e Assinar", en: "Open and Sign" },
    "trainingAssessment": { pt: "Avaliação de Treinamento", en: "Training Assessment" },
    "totalQuestions": { pt: "Total de Questões", en: "Total Questions" },
    "minimumScore": { pt: "Nota Mínima", en: "Minimum Score" },
    "time": { pt: "Tempo", en: "Time" },
    "noLimit": { pt: "Sem limite", en: "No limit" },
    "attempts": { pt: "Tentativas", en: "Attempts" },
    "unlimited": { pt: "Ilimitadas", en: "Unlimited" },
    "lastAttempt": { pt: "Última Tentativa", en: "Last Attempt" },
    "score": { pt: "Pontuação", en: "Score" },
    "status": { pt: "Status", en: "Status" },
    "passed": { pt: "Aprovado", en: "Passed" },
    "failed": { pt: "Reprovado", en: "Failed" },
    "date": { pt: "Data", en: "Date" },
    "startTraining": { pt: "Iniciar Treinamento", en: "Start Training" },
    "retakeTraining": { pt: "Fazer Novamente", en: "Retake Training" },
    "attemptHistory": { pt: "Histórico de Tentativas", en: "Attempt History" },
    "noAttempts": { pt: "Você ainda não fez nenhuma tentativa.", en: "You haven't made any attempts yet." },
    "attempt": { pt: "Tentativa", en: "Attempt" },

    // Reports Page
    "noReportsFor": { pt: "Não há relatórios para", en: "No reports for" },
    "reportsOf": { pt: "Relatórios de", en: "Reports of" },
    "myWeeklyReports": { pt: "Meus Relatórios Semanais", en: "My Weekly Reports" },
    "weekOf": { pt: "Semana de", en: "Week of" },
    "totalWorked": { pt: "Total Trabalhado", en: "Total Worked" },
    "totalLunch": { pt: "Total Breaks Pagos", en: "Total Paid Breaks" },
    "totalTravel": { pt: "Total Trajeto", en: "Total Travel" },
    "totalClosing": { pt: "Fechamento Total", en: "Total Closing" },
    "week": { pt: "Semana", en: "Week" },
    "lastEdit": { pt: "Última Edição", en: "Last Edit" },
    "actions": { pt: "Ações", en: "Actions" },
    "openEdit": { pt: "Abrir / Editar", en: "Open / Edit" },
    "editHistory": { pt: "Histórico de Edições", en: "Edit History" },
    "when": { pt: "Quando", en: "When" },
    "user": { pt: "Usuário", en: "User" },
    "changes": { pt: "Alterações", en: "Changes" },
    "clientTimeChanged": { pt: "O tempo do cliente", en: "Client time for" },
    "wasChangedFrom": { pt: "foi alterado de", en: "was changed from" },
    "to": { pt: "para", en: "to" },

    // Colaborador Page
    "weekClosing": { pt: "Fechamento da Semana", en: "Weekly Closing" },
    "weeklySummary": { pt: "Resumo Semanal", en: "Weekly Summary" },
    "hoursWorked": { pt: "Horas Trabalhadas", en: "Hours Worked" },
    "saveClosing": { pt: "Salvar Fechamento", en: "Save Closing" },
    "searchClient": { pt: "Pesquisar cliente...", en: "Search client..." },
    "add": { pt: "Adicionar", en: "Add" },
    "name": { pt: "Nome", en: "Name" },
    "address": { pt: "Endereço", en: "Address" },
    "addressAuckland": { pt: "Endereço", en: "Address" },
    "startTyping": { pt: "Comece a digitar...", en: "Start typing..." },
    "hours": { pt: "Horas HH:MM", en: "Hours HH:MM" },
    "fillClientName": { pt: "Preencha o nome do cliente.", en: "Please fill in the client name." },
    "selectValidAddress": { pt: "Selecione um endereço válido de Auckland.", en: "Select a valid Auckland address." },
    "hoursFormat": { pt: "Horas em formato HH:MM.", en: "Hours in HH:MM format." },
    "total": { pt: "Total", en: "Total" },
    "edit": { pt: "Editar", en: "Edit" },
    "justificationRequired": { pt: "Justificativa obrigatória ao aumentar tempo.", en: "Justification required when increasing time." },
    "justification": { pt: "Justificativa", en: "Justification" },
    "closingSaved": { pt: "✅ Fechamento salvo!", en: "✅ Closing saved!" },
    "errorLoadingMaps": { pt: "Erro ao carregar Google Maps", en: "Error loading Google Maps" },
    "importFromCalendar": { pt: "Importar do Calendário", en: "Import from Calendar" },
    "importing": { pt: "Importando...", en: "Importing..." },
    "confirmReimport": { pt: "Substituir dados atuais com dados do calendário?", en: "Replace current data with calendar data?" },
    "jobsImported": { pt: "jobs importados do calendário", en: "jobs imported from calendar" },
    "noCalendarData": { pt: "Nenhum dado encontrado no calendário para esta semana", en: "No calendar data found for this week" },
    "importError": { pt: "Erro ao importar dados do calendário", en: "Error importing calendar data" },
    "compareCalendar": { pt: "Comparar", en: "Compare" },
    "compareTitle": { pt: "Calendário vs Fechamento", en: "Calendar vs Report" },
    "calendarLabel": { pt: "Calendário", en: "Calendar" },
    "reportLabel": { pt: "Fechamento", en: "Report" },
    "missingInReport": { pt: "Faltando", en: "Missing" },
    "extraInReport": { pt: "Extra", en: "Extra" },
    "calendarPP": { pt: "Cal /pessoa", en: "Cal /person" },
    "people": { pt: "pessoas", en: "people" },

    // Reports Filters
    "filterByDate": { pt: "Filtrar por Data", en: "Filter by Date" },
    "clearFilter": { pt: "Limpar filtro", en: "Clear filter" },
    "sortBy": { pt: "Ordenar por", en: "Sort by" },
    "newestFirst": { pt: "Mais recentes primeiro", en: "Newest first" },
    "oldestFirst": { pt: "Mais antigas primeiro", en: "Oldest first" },
    "noResultsForFilter": { pt: "Nenhum resultado encontrado", en: "No results found" },
    "tryDifferentDates": { pt: "Tente ajustar o intervalo de datas.", en: "Try adjusting the date range." },
    "startDate": { pt: "Data Inicial", en: "Start Date" },
    "endDate": { pt: "Data Final", en: "End Date" },
    "filtersSearch": { pt: "Filtros & Busca", en: "Filters & Search" },

    // Admin Users Page
    "adminPanel": { pt: "Painel Admin: Usuários", en: "Admin Panel: Users" },
    "addUser": { pt: "Adicionar Usuário", en: "Add User" },
    "addingUser": { pt: "Adicionando…", en: "Adding…" },
    "fillNameEmail": { pt: "Preencha nome e e-mail.", en: "Fill in name and email." },
    "errorAddingUser": { pt: "Erro ao adicionar usuário.", en: "Error adding user." },
    "errorUpdatingPermission": { pt: "Erro ao atualizar permissão.", en: "Error updating permission." },
    "errorDeletingUser": { pt: "Erro ao excluir usuário.", en: "Error deleting user." },
    "deleteUserConfirm": { pt: "Excluir usuário", en: "Delete user" },
    "editUser": { pt: "Editar Usuário", en: "Edit User" },
    "userName": { pt: "Nome", en: "Name" },
    "displayName": { pt: "Nome de exibição", en: "Display name" },
    "email": { pt: "E-mail", en: "Email" },
    "isAdmin": { pt: "Admin?", en: "Admin?" },
    "actions": { pt: "Ações", en: "Actions" },
    "edit": { pt: "Editar", en: "Edit" },
    "delete": { pt: "Excluir", en: "Delete" },
    "removeAdmin": { pt: "Remover Admin", en: "Remove Admin" },
    "makeAdmin": { pt: "Tornar Admin", en: "Make Admin" },
    "yes": { pt: "Sim", en: "Yes" },
    "no": { pt: "Não", en: "No" },
    "saving": { pt: "Salvando…", en: "Saving…" },

    // Clients Page
    "manageClients": { pt: "Gerenciar Clientes", en: "Manage Clients" },
    "clientName": { pt: "Nome do Cliente", en: "Client Name" },
    "address": { pt: "Endereço", en: "Address" },
    "hours": { pt: "Horas Padrão", en: "Default Hours" },
    "hoursFormat": { pt: "Horas (HH:MM)", en: "Hours (HH:MM)" },
    "addClient": { pt: "Adicionar", en: "Add" },
    "fillClientFields": { pt: "Preencha Nome, Endereço e Horas (HH:MM).", en: "Fill in Name, Address and Hours (HH:MM)." },
    "errorAddingClient": { pt: "Erro ao adicionar cliente.", en: "Error adding client." },
    "errorSavingClient": { pt: "Erro ao salvar cliente.", en: "Error saving client." },
    "errorDeletingClient": { pt: "Erro ao excluir cliente.", en: "Error deleting client." },
    "confirmDeleteClient": { pt: "Confirma exclusão deste cliente?", en: "Confirm deletion of this client?" },
    "editClient": { pt: "Editar Cliente", en: "Edit Client" },
    "cancel": { pt: "Cancelar", en: "Cancel" },
    "save": { pt: "Salvar", en: "Save" },
    "accessDenied": { pt: "Acesso negado.", en: "Access denied." },

    // Health & Safety Training
    "healthSafetyTraining": { pt: "Avaliação de Treinamento", en: "Training Assessment" },
    "minimumScore": { pt: "Nota Mínima", en: "Minimum Score" },
    "noTimeLimit": { pt: "Sem limite", en: "No limit" },
    "unlimitedAttempts": { pt: "Ilimitadas", en: "Unlimited" },
    "lastAttempt": { pt: "Última Tentativa", en: "Last Attempt" },
    "noAttempts": { pt: "Você ainda não fez nenhuma tentativa.", en: "You haven't made any attempts yet." },
    "attempt": { pt: "Tentativa", en: "Attempt" },

    // Gallery & Documents (NEW)
    "gallery": { pt: "Galeria de Arquivos", en: "File Gallery" },
    "noFilesFound": { pt: "Nenhum arquivo encontrado para este cliente neste dia.", en: "No files found for this client on this day." },
    "uploading": { pt: "Fazendo upload...", en: "Uploading..." },
    "uploadError": { pt: "Erro ao fazer upload", en: "Upload error" },
    "filesReady": { pt: "arquivo(s) pronto(s)", en: "file(s) ready" },
    "filesSaved": { pt: "arquivo(s) já salvo(s)", en: "file(s) already saved" },
    "newFiles": { pt: "novo(s)", en: "new" },
    "visualizeFiles": { pt: "Visualizar Arquivos", en: "View Files" },
    "saveAndVisualize": { pt: "Salvar e Visualizar", en: "Save and View" },
    "photosVideos": { pt: "Fotos/Vídeos", en: "Photos/Videos" },

    // Documents Page (NEW)
    "serviceDocuments": { pt: "Documentos de Serviços", en: "Service Documents" },
    "serviceDocumentsSubtitle": { pt: "Visualize todas as fotos e vídeos dos serviços realizados", en: "View all photos and videos of completed services" },
    "searchByClient": { pt: "Buscar por cliente...", en: "Search by client..." },
    "loadingDocuments": { pt: "Carregando documentos...", en: "Loading documents..." },
    "noDocumentsFound": { pt: "Nenhum documento encontrado", en: "No documents found" },
    "noDocumentsForClient": { pt: "Nenhum documento encontrado para", en: "No documents found for" },
    "noDocumentsYet": { pt: "Nenhum documento encontrado. Quando os colaboradores anexarem fotos, elas aparecerão aqui.", en: "No documents found. When employees attach photos, they will appear here." },
    "files": { pt: "arquivos", en: "files" },
    "file": { pt: "arquivo", en: "file" },
    "schedule": { pt: "Horário", en: "Schedule" },
    "downloadAll": { pt: "Baixar Tudo (ZIP)", en: "Download All (ZIP)" },
    "downloading": { pt: "Baixando...", en: "Downloading..." },
    "openInNewTab": { pt: "Abrir em nova aba", en: "Open in new tab" },

    // Calendar Page (NEW)
    "calendar": { pt: "Calendário de Jobs", en: "Jobs Calendar" },
    "calendarSubtitle": { pt: "Gerencie agendamentos, clientes e tarefas", en: "Manage schedules, clients and tasks" },
    "newJob": { pt: "Novo Job", en: "New Job" },
    "editJob": { pt: "Editar Job", en: "Edit Job" },
    "viewJob": { pt: "Ver Job", en: "View Job" },
    "selectClient": { pt: "Selecione um cliente", en: "Select a client" },
    "selectEmployee": { pt: "Selecione um colaborador", en: "Select an employee" },
    "startTime": { pt: "Hora de Início", en: "Start Time" },
    "endTime": { pt: "Hora de Término", en: "End Time" },
    "notes": { pt: "Observações", en: "Notes" },
    "checklist": { pt: "Checklist", en: "Checklist" },
    "addChecklistItem": { pt: "Adicionar item", en: "Add item" },
    "scheduled": { pt: "Agendado", en: "Scheduled" },
    "completed": { pt: "Completo", en: "Completed" },
    "cancelled": { pt: "Cancelado", en: "Cancelled" },
    "deleteJob": { pt: "Excluir Job", en: "Delete Job" },
    "confirmDeleteJob": { pt: "Tem certeza que deseja excluir este job?", en: "Are you sure you want to delete this job?" },
    "openInMaps": { pt: "Abrir no Google Maps", en: "Open in Google Maps" },
    "phone": { pt: "Telefone", en: "Phone" },
    "noClientsFound": { pt: "Nenhum cliente cadastrado", en: "No clients registered" },
    "noEmployeesFound": { pt: "Nenhum colaborador cadastrado", en: "No employees registered" },
    "errorLoadingClients": { pt: "Erro ao carregar clientes", en: "Error loading clients" },
    "errorLoadingEmployees": { pt: "Erro ao carregar colaboradores", en: "Error loading employees" },
    "errorLoadingJobs": { pt: "Erro ao carregar jobs", en: "Error loading jobs" },
    "errorSavingJob": { pt: "Erro ao salvar job", en: "Error saving job" },
    "errorDeletingJob": { pt: "Erro ao excluir job", en: "Error deleting job" },

    // Tutorial Page
    "tutorialTitle": { pt: "Tutorial - Como Usar o App", en: "Tutorial - How to Use the App" },
    "tutorialSubtitle": { pt: "Guia passo a passo para novos colaboradores", en: "Step-by-step guide for new employees" },
    "tutorialWeeklyReport": { pt: "Fechamento Semanal", en: "Weekly Report" },
    "tutorialCalendar": { pt: "Calendário", en: "Calendar" },
    "tutorialHelp": { pt: "Ajuda", en: "Help" },
    "tutorialViewTutorial": { pt: "Ver Tutorial", en: "View Tutorial" },
    "tutorialAppTutorial": { pt: "Tutorial do App", en: "App Tutorial" },
    "tutorialAppTutorialDesc": { pt: "Aprenda a usar o app passo a passo", en: "Learn how to use the app step by step" },

    // Tutorial - Fechamento Semanal
    "tutorialNavWeeks": { pt: "Navegar entre semanas", en: "Navigate between weeks" },
    "tutorialNavWeeksDesc": { pt: "Use as setas ← → no topo da página para ir para a semana anterior ou próxima. A semana atual é mostrada entre as setas.", en: "Use the ← → arrows at the top of the page to go to the previous or next week. The current week is shown between the arrows." },
    "tutorialAddClients": { pt: "Adicionar clientes ao dia", en: "Add clients to a day" },
    "tutorialAddClientsDesc": { pt: "Cada dia da semana tem um card. Use o campo de busca para encontrar um cliente já cadastrado. Se o cliente não existir, digite o nome e clique em '➕ Adicionar' para criar manualmente.", en: "Each day of the week has a card. Use the search field to find a registered client. If the client doesn't exist, type the name and click '➕ Add' to create manually." },
    "tutorialAddClientsManual": { pt: "Ao adicionar manualmente, você precisará informar: Nome, Endereço e Horas (formato HH:MM).", en: "When adding manually, you'll need to provide: Name, Address and Hours (HH:MM format)." },
    "tutorialEditHours": { pt: "Editar horas de um cliente", en: "Edit client hours" },
    "tutorialEditHoursDesc": { pt: "Clique no ícone de lápis ✏️ ao lado do cliente para abrir o modal de edição. Você pode alterar as horas trabalhadas.", en: "Click the pencil icon ✏️ next to the client to open the edit modal. You can change the worked hours." },
    "tutorialEditHoursColors": { pt: "Horas em vermelho = tempo aumentou. Horas em verde = tempo diminuiu.", en: "Red hours = time increased. Green hours = time decreased." },
    "tutorialJustification": { pt: "Justificativa ao aumentar horas", en: "Justification when increasing hours" },
    "tutorialJustificationDesc": { pt: "Se você aumentar o tempo de um cliente, o sistema vai exigir uma justificativa. Explique o motivo do aumento no campo de texto.", en: "If you increase a client's time, the system will require a justification. Explain the reason for the increase in the text field." },
    "tutorialTeamSize": { pt: "Definir quantidade de pessoas no team", en: "Set team size" },
    "tutorialTeamSizeDesc": { pt: "No canto superior direito de cada dia, há um campo numérico com o ícone 👥. Defina quantas pessoas trabalharam naquele dia. As horas serão divididas automaticamente.", en: "In the upper right corner of each day, there's a number field with the 👥 icon. Set how many people worked that day. Hours are divided automatically." },
    "tutorialSave": { pt: "Salvar o fechamento", en: "Save the report" },
    "tutorialSaveDesc": { pt: "Depois de preencher todos os dias, clique no botão verde 'Salvar Fechamento' no topo da página.", en: "After filling in all days, click the green 'Save Report' button at the top of the page." },
    "tutorialSaveWarning": { pt: "Salve o relatório ANTES de fechar a página, senão as alterações serão perdidas!", en: "Save the report BEFORE closing the page, otherwise changes will be lost!" },
    "tutorialSummary": { pt: "Entender o resumo semanal", en: "Understanding the weekly summary" },
    "tutorialSummaryWork": { pt: "Horas Trabalhadas: total de horas de trabalho efetivo", en: "Hours Worked: total effective working hours" },
    "tutorialSummaryBreaks": { pt: "Total Almoço: pausas pagas calculadas automaticamente", en: "Total Lunch: paid breaks calculated automatically" },
    "tutorialSummaryTravel": { pt: "Total Trajeto: tempo de deslocamento entre clientes", en: "Total Travel: travel time between clients" },
    "tutorialSummaryTotal": { pt: "Fechamento Total: soma de trabalho + almoço + trajeto", en: "Total Closing: sum of work + lunch + travel" },

    // Tutorial - Calendario
    "tutorialViewJobs": { pt: "Ver os jobs agendados", en: "View scheduled jobs" },
    "tutorialViewJobsDesc": { pt: "No menu lateral, clique em 'Calendário'. Você verá todos os jobs agendados para o dia ou semana.", en: "In the side menu, click 'Calendar'. You'll see all scheduled jobs for the day or week." },
    "tutorialJobDetails": { pt: "Ver detalhes de um job", en: "View job details" },
    "tutorialJobDetailsDesc": { pt: "Clique em qualquer job para ver as informações completas:", en: "Click on any job to see full details:" },
    "tutorialJobTime": { pt: "Horário de início e fim", en: "Start and end time" },
    "tutorialJobAddress": { pt: "Endereço do cliente (com link para Google Maps)", en: "Client address (with Google Maps link)" },
    "tutorialJobChecklist": { pt: "Checklist de tarefas a fazer", en: "Task checklist" },
    "tutorialJobNotes": { pt: "Observações e instruções", en: "Notes and instructions" },
    "tutorialJobPassword": { pt: "Senha/código de acesso (se houver)", en: "Password/access code (if any)" },
    "tutorialUploadPhotos": { pt: "Enviar fotos/vídeos de um job", en: "Upload photos/videos to a job" },
    "tutorialUploadPhotosDesc": { pt: "Esta é a forma de enviar fotos do serviço! Depois de abrir um job:", en: "This is the way to send service photos! After opening a job:" },
    "tutorialUploadStep1": { pt: "Role para baixo até 'Fotos/Vídeos'", en: "Scroll down to 'Photos/Videos'" },
    "tutorialUploadStep2": { pt: "Clique para selecionar arquivos do celular", en: "Click to select files from your phone" },
    "tutorialUploadStep3": { pt: "Aguarde o upload terminar (barra de progresso)", en: "Wait for the upload to finish (progress bar)" },
    "tutorialUploadStep4": { pt: "Clique em 'Salvar' para confirmar", en: "Click 'Save' to confirm" },
    "tutorialUploadTip": { pt: "Você pode enviar múltiplas fotos de uma vez.", en: "You can send multiple photos at once." },
    "tutorialViewGallery": { pt: "Ver a galeria de fotos", en: "View the photo gallery" },
    "tutorialViewGalleryDesc": { pt: "Depois de salvar, clique em 'Visualizar Arquivos' para ver todas as fotos. Navegue com setas ou swipe no celular.", en: "After saving, click 'View Files' to see all photos. Navigate with arrows or swipe on mobile." },
    "tutorialTip": { pt: "Dica", en: "Tip" },
    "tutorialImportant": { pt: "Importante", en: "Important" },

    // Tutorial - Instalar no Celular
    "tutorialInstallApp": { pt: "Instalar no Celular", en: "Install on Phone" },
    "tutorialInstallDesc": { pt: "Adicione o app na tela inicial do seu celular para acessar mais rápido, sem precisar abrir o navegador.", en: "Add the app to your phone's home screen for quicker access, without opening the browser." },
    "tutorialAndroid": { pt: "Android (Chrome)", en: "Android (Chrome)" },
    "tutorialAndroidStep1": { pt: "Abra o site no Google Chrome", en: "Open the site in Google Chrome" },
    "tutorialAndroidStep2": { pt: "Toque nos 3 pontinhos (⋮) no canto superior direito", en: "Tap the 3 dots (⋮) in the top right corner" },
    "tutorialAndroidStep3": { pt: "Toque em 'Adicionar à tela inicial' ou 'Instalar aplicativo'", en: "Tap 'Add to Home screen' or 'Install app'" },
    "tutorialAndroidStep4": { pt: "Confirme o nome e toque em 'Adicionar'", en: "Confirm the name and tap 'Add'" },
    "tutorialAndroidStep5": { pt: "Pronto! O ícone aparece na sua tela inicial", en: "Done! The icon appears on your home screen" },
    "tutorialIphone": { pt: "iPhone (Safari)", en: "iPhone (Safari)" },
    "tutorialIphoneStep1": { pt: "Abra o site no Safari (obrigatório ser o Safari)", en: "Open the site in Safari (must be Safari)" },
    "tutorialIphoneStep2": { pt: "Toque no botão de compartilhar (quadrado com seta ⬆️) na barra inferior", en: "Tap the share button (square with arrow ⬆️) at the bottom bar" },
    "tutorialIphoneStep3": { pt: "Role para baixo e toque em 'Adicionar à Tela de Início'", en: "Scroll down and tap 'Add to Home Screen'" },
    "tutorialIphoneStep4": { pt: "Confirme o nome e toque em 'Adicionar'", en: "Confirm the name and tap 'Add'" },
    "tutorialIphoneStep5": { pt: "Pronto! O app abre em tela cheia, sem barra do navegador", en: "Done! The app opens full screen, without the browser bar" },
    "tutorialIphoneWarning": { pt: "No iPhone, só funciona pelo Safari. Se usar Chrome ou outro navegador, a opção não aparece.", en: "On iPhone, this only works in Safari. If you use Chrome or another browser, the option won't appear." },

    // Quotes Manager
    "quotesTitle": { pt: "Orçamentos", en: "Quotes" },
    "quotesNew": { pt: "Novo Orçamento", en: "New Quote" },
    "quotesEdit": { pt: "Editar Orçamento", en: "Edit Quote" },
    "quotesEmpty": { pt: "Nenhum orçamento encontrado", en: "No quotes found" },
    "quotesEmptyDesc": { pt: "Crie seu primeiro orçamento clicando no botão acima", en: "Create your first quote using the button above" },
    "quotesNumber": { pt: "Número", en: "Number" },
    "quotesClient": { pt: "Cliente", en: "Client" },
    "quotesDate": { pt: "Data", en: "Date" },
    "quotesExpiry": { pt: "Validade", en: "Expiry" },
    "quotesTotal": { pt: "Total", en: "Total" },
    "quotesStatus": { pt: "Status", en: "Status" },
    "quotesActions": { pt: "Ações", en: "Actions" },
    "quotesClientName": { pt: "Nome do Cliente", en: "Client Name" },
    "quotesDescription": { pt: "Descrição", en: "Description" },
    "quotesQuantity": { pt: "Qtd", en: "Qty" },
    "quotesUnitPrice": { pt: "Valor Unitário", en: "Unit Price" },
    "quotesAddItem": { pt: "Adicionar Item", en: "Add Item" },
    "quotesRemoveItem": { pt: "Remover", en: "Remove" },
    "quotesOptionalFields": { pt: "Campos Opcionais", en: "Optional Fields" },
    "quotesReference": { pt: "Referência", en: "Reference" },
    "quotesTerms": { pt: "Termos", en: "Terms" },
    "quotesSummary": { pt: "Resumo", en: "Summary" },
    "quotesSendEmail": { pt: "Enviar por Email", en: "Send by Email" },
    "quotesDownloadPdf": { pt: "Baixar PDF", en: "Download PDF" },
    "quotesConfirmDelete": { pt: "Tem certeza que deseja excluir este orçamento?", en: "Are you sure you want to delete this quote?" },
    "quotesCreated": { pt: "Orçamento criado com sucesso!", en: "Quote created successfully!" },
    "quotesUpdated": { pt: "Orçamento atualizado com sucesso!", en: "Quote updated successfully!" },
    "quotesDeleted": { pt: "Orçamento excluído com sucesso!", en: "Quote deleted successfully!" },
    "quotesEmailSent": { pt: "Orçamento enviado por email!", en: "Quote sent by email!" },
    "quotesErrorLoading": { pt: "Erro ao carregar orçamentos", en: "Error loading quotes" },
    "quotesErrorCreating": { pt: "Erro ao criar orçamento", en: "Error creating quote" },
    "quotesErrorUpdating": { pt: "Erro ao atualizar orçamento", en: "Error updating quote" },
    "quotesErrorDeleting": { pt: "Erro ao excluir orçamento", en: "Error deleting quote" },
    "quotesErrorEmail": { pt: "Erro ao enviar email", en: "Error sending email" },
    "quotesErrorPdf": { pt: "Erro ao baixar PDF", en: "Error downloading PDF" },
    "quotesFilterAll": { pt: "Todos", en: "All" },
    "quotesSearch": { pt: "Buscar por cliente...", en: "Search by client..." },
    "quotesTitle2": { pt: "Título", en: "Title" },

    // Payroll
    "payrollTitle": { pt: "Folha de Pagamento", en: "Payroll" },
    "payrollSetup": { pt: "Configuração", en: "Setup" },
    "payrollWeekly": { pt: "Payroll Semanal", en: "Weekly Payroll" },
    "payrollHistory": { pt: "Histórico", en: "History" },
    "payrollEmployee": { pt: "Funcionário", en: "Employee" },
    "payrollHours": { pt: "Horas", en: "Hours" },
    "payrollRate": { pt: "Taxa ($/hr)", en: "Rate ($/hr)" },
    "payrollHourlyRate": { pt: "Taxa Horária", en: "Hourly Rate" },
    "payrollGross": { pt: "Bruto", en: "Gross" },
    "payrollNet": { pt: "Líquido", en: "Net" },
    "payrollNetPay": { pt: "Pagamento Líquido", en: "Net Pay" },
    "payrollTotal": { pt: "Total", en: "Total" },
    "payrollActions": { pt: "Ações", en: "Actions" },
    "payrollPending": { pt: "Pendente", en: "Pending" },
    "payrollApproved": { pt: "Aprovado", en: "Approved" },
    "payrollSentToXero": { pt: "No Xero", en: "In Xero" },
    "payrollPaid": { pt: "Pago", en: "Paid" },
    "payrollApproveBtn": { pt: "Aprovar", en: "Approve" },
    "payrollUnapprove": { pt: "Desfazer", en: "Undo" },
    "payrollCalculate": { pt: "Calcular", en: "Calculate" },
    "payrollSendToXero": { pt: "Enviar ao Xero", en: "Send to Xero" },
    "payrollApprovePayrun": { pt: "Aprovar Pay Run", en: "Approve Pay Run" },
    "payrollViewPayslip": { pt: "Ver Payslip", en: "View Payslip" },
    "payrollApproveAll": { pt: "Aprovar Todos", en: "Approve All" },
    "payrollApprovedSuccess": { pt: "Fechamento aprovado com sucesso", en: "Report approved successfully" },
    "payrollUnapprovedSuccess": { pt: "Aprovação desfeita", en: "Approval undone" },
    "payrollSentSuccess": { pt: "Enviado ao Xero com sucesso", en: "Sent to Xero successfully" },
    "payrollPayrunApproved": { pt: "Pay run aprovado no Xero", en: "Pay run approved in Xero" },
    "payrollAllApproved": { pt: "Todos aprovados com sucesso", en: "All approved successfully" },
    "payrollPreviewTitle": { pt: "Preview do Payroll", en: "Payroll Preview" },
    "payrollPayslipTitle": { pt: "Payslip - Detalhes", en: "Payslip - Details" },
    "payrollPeriod": { pt: "Período", en: "Period" },
    "payrollEarnings": { pt: "Rendimentos", en: "Earnings" },
    "payrollDeductions": { pt: "Deduções", en: "Deductions" },
    "payrollWeek": { pt: "Semana", en: "Week" },
    "payrollNoData": { pt: "Nenhum dado para esta semana", en: "No data for this week" },
    "payrollNoHistory": { pt: "Nenhum histórico de pagamento", en: "No payment history" },
    "payrollNotMapped": { pt: "Sem Xero", en: "No Xero" },
    "payrollUnmappedWarning": { pt: "{count} funcionário(s) sem mapeamento Xero", en: "{count} employee(s) not mapped to Xero" },
    "payrollGoToSetup": { pt: "Ir para Configuração", en: "Go to Setup" },
    "payrollMappingTitle": { pt: "Mapeamento Funcionário ↔ Xero", en: "Employee ↔ Xero Mapping" },
    "payrollMappingDesc": { pt: "Conecte os funcionários do app com os do Xero Payroll", en: "Connect app employees with Xero Payroll employees" },
    "payrollAppUser": { pt: "Funcionário (App)", en: "Employee (App)" },
    "payrollXeroEmployee": { pt: "Funcionário (Xero)", en: "Employee (Xero)" },
    "payrollSelectEmployee": { pt: "Selecionar...", en: "Select..." },
    "payrollMappingSaved": { pt: "Mapeamento salvo", en: "Mapping saved" },
    "payrollMappingDeleted": { pt: "Mapeamento removido", en: "Mapping removed" },
    "payrollNoXeroEmployees": { pt: "Não foi possível carregar funcionários do Xero. Verifique os scopes do OAuth.", en: "Could not load Xero employees. Check OAuth scopes." },
    "payrollViewReport": { pt: "Ver", en: "View" },
    "payrollFechamentoTitle": { pt: "Fechamento Semanal", en: "Weekly Report" },
    "payrollWorkers": { pt: "pessoas", en: "workers" },
    "payrollWorkHours": { pt: "Horas", en: "Hours" },
    "payrollTravel": { pt: "Trajeto", en: "Travel" },
    "payrollWorkHoursTotal": { pt: "Horas Trabalhadas", en: "Work Hours" },
    "payrollFechamentoTotal": { pt: "Fechamento Total", en: "Total Closing" },
    "payrollOriginal": { pt: "Fechamento", en: "Report" },
    "payrollReset": { pt: "Resetar", en: "Reset" },
    "payrollSendAllToXero": { pt: "Enviar ao Xero", en: "Send to Xero" },
    "payrollEstimate": { pt: "estimativa", en: "estimate" },

    // Home Page
    "homeWelcome": { pt: "Bem-vindo(a) de volta", en: "Welcome back" },
    "homeManageReports": { pt: "Gerencie seus relatórios semanais e acompanhe seu progresso", en: "Manage your weekly reports and track your progress" },
    "homeEmployeeReports": { pt: "Relatórios de Colaboradores", en: "Employee Reports" },
    "homeViewManageReports": { pt: "Visualize e gerencie todos os relatórios de colaboradores", en: "View and manage all employee weekly reports" },
    "homeAccessReports": { pt: "Acessar Relatórios", en: "Access Reports" },
    "homeManageClients": { pt: "Gerenciar Clientes", en: "Manage Clients" },
    "homeManageClientsDesc": { pt: "Adicione, edite e gerencie informações de clientes", en: "Add, edit, and manage client information" },
    "homeWeeklyReport": { pt: "Fechamento Semanal", en: "Weekly Report" },
    "homeCreateReport": { pt: "Crie e envie seu fechamento semanal", en: "Create and submit your weekly closing report" },
    "homeSubmitReport": { pt: "Fazer Fechamento", en: "Submit Report" },
    "homeViewReports": { pt: "Ver Relatórios", en: "View Reports" },
    "homeViewReportsDesc": { pt: "Acesse seus relatórios anteriores e histórico", en: "Access your previous reports and history" },
    "homeAppTutorial": { pt: "Tutorial do App", en: "App Tutorial" },
    "homeLearnApp": { pt: "Aprenda a usar o app passo a passo", en: "Learn how to use the app step by step" },
    "homeViewTutorial": { pt: "Ver Tutorial", en: "View Tutorial" },
    "homeNeedHelp": { pt: "Precisa de Ajuda?", en: "Need Help?" },
    "homeHealthSafetyDocs": { pt: "Confira nossa documentação de Saúde e Segurança para mais informações", en: "Check our Health & Safety documentation for more information" },
    "homeLearnMore": { pt: "Saiba Mais", en: "Learn More" },

    // Invoice History Page
    "invoiceTitle": { pt: "Histórico de Invoices", en: "Invoice History" },
    "invoiceSyncClients": { pt: "Sincronizar Clientes", en: "Sync Clients" },
    "invoiceSyncing": { pt: "Sincronizando...", en: "Syncing..." },
    "invoiceSearchPlaceholder": { pt: "Buscar por cliente, número da invoice ou descrição...", en: "Search by client, invoice number, or description..." },
    "invoiceTotalInvoices": { pt: "Total de invoices:", en: "Total invoices:" },
    "invoiceTotalAmount": { pt: "Valor total:", en: "Total amount:" },
    "invoiceNoFound": { pt: "Nenhuma invoice encontrada para sua busca.", en: "No invoices found matching your search." },
    "invoiceNoSent": { pt: "Nenhuma invoice enviada ainda. Vá para o calendário para enviar invoices!", en: "No invoices sent yet. Go to the calendar to send invoices!" },
    "invoiceNum": { pt: "Invoice #", en: "Invoice #" },
    "invoiceClient": { pt: "Cliente", en: "Client" },
    "invoiceDate": { pt: "Data", en: "Date" },
    "invoiceDescription": { pt: "Descrição", en: "Description" },
    "invoiceAmount": { pt: "Valor", en: "Amount" },
    "invoiceStatus": { pt: "Status", en: "Status" },
    "invoiceSentAt": { pt: "Enviado em", en: "Sent At" },
    "invoiceSentBy": { pt: "Enviado por", en: "Sent By" },
    "invoiceDraft": { pt: "Rascunho", en: "Draft" },
    "invoiceSubmitted": { pt: "Enviado", en: "Submitted" },
    "invoiceApproved": { pt: "Aprovado", en: "Approved" },
    "invoicePaid": { pt: "Pago", en: "Paid" },
    "invoiceSendReminders": { pt: "Enviar Lembretes WhatsApp", en: "Send WhatsApp Reminders" },
    "invoiceOverdueTitle": { pt: "Lembretes de Invoice por WhatsApp", en: "WhatsApp Invoice Reminders" },
    "invoiceSelectAll": { pt: "Selecionar Todos", en: "Select All" },
    "invoiceDeselectAll": { pt: "Desmarcar Todos", en: "Deselect All" },
    "invoiceDaysOverdue": { pt: "Dias Atrasado", en: "Days Overdue" },
    "invoiceSendReminder": { pt: "Enviar", en: "Send" },
    "invoiceSending": { pt: "Enviando...", en: "Sending..." },
    "invoiceRemindersSent": { pt: "Enviados {sent} de {total} lembretes", en: "Sent {sent} of {total} reminders" },
    "invoiceNoOverdue": { pt: "Nenhuma invoice atrasada encontrada!", en: "No overdue invoices found!" },
    "invoiceMessageTemplate": { pt: "Template da mensagem:", en: "Message template:" },
    "invoiceLoadingInvoices": { pt: "Carregando invoices...", en: "Loading invoices..." },
    "invoiceErrorOverdue": { pt: "Erro ao buscar invoices atrasadas. Verifique o console.", en: "Error fetching overdue invoices. Check console for details." },
    "invoiceSyncSuccess": { pt: "{count} clientes sincronizados com sucesso!", en: "Successfully synced {count} clients!" },
    "invoiceSyncError": { pt: "Erro ao sincronizar clientes. Verifique o console.", en: "Error syncing clients. Check console for details." },
    "invoiceErrorReminders": { pt: "Erro ao enviar lembretes. Verifique o console.", en: "Error sending reminders. Check console for details." },
    "invoiceSelectOneInvoice": { pt: "Por favor, selecione pelo menos uma invoice.", en: "Please select at least one invoice." },
    "invoiceSent": { pt: "Enviado", en: "Sent" },
    "invoiceFailed": { pt: "Falhou", en: "Failed" },
    "invoiceDays": { pt: "dias", en: "days" },
    "invoiceReminder": { pt: "Lembrete", en: "Reminder" },
    "invoiceReminders": { pt: "Lembretes", en: "Reminders" },

    // Revenue Page
    "revenueTitle": { pt: "Relatório de Faturamento", en: "Revenue Report" },
    "revenueAnnual": { pt: "Anual", en: "Annual" },
    "revenueMonthly": { pt: "Mensal", en: "Monthly" },
    "revenueWeekly": { pt: "Semanal", en: "Weekly" },
    "revenuePrevious": { pt: "Anterior", en: "Previous" },
    "revenueCurrent": { pt: "Atual", en: "Current" },
    "revenueNext": { pt: "Próximo", en: "Next" },
    "revenueNoAmountWarning": { pt: "Clientes sem valor de invoice definido", en: "Clients without invoice amount set" },
    "revenueNoAmountDesc": { pt: "Os seguintes clientes não têm um valor padrão de invoice definido. Por favor, adicione os valores:", en: "The following clients don't have a default invoice amount set. Please add their values:" },
    "revenueByTeam": { pt: "Faturamento por Time", en: "Revenue by Team" },
    "revenueOverallTotals": { pt: "Totais Gerais", en: "Overall Totals" },
    "revenueBankAccount": { pt: "Conta", en: "Bank Account" },
    "revenueTotal": { pt: "Total", en: "Total" },
    "revenueGstWeek": { pt: "Essa semana você deve pagar esse valor de GST:", en: "This week you need to pay this GST amount:" },
    "revenueGstPercent": { pt: "15% do valor da Conta:", en: "15% of Bank Account amount:" },
    "revenueByClient": { pt: "Faturamento por Cliente", en: "Revenue by Client" },
    "revenueClient": { pt: "Cliente", en: "Client" },
    "revenueJobs": { pt: "Jobs", en: "Jobs" },
    "revenueServiceDates": { pt: "Datas dos Serviços", en: "Service Dates" },
    "revenueAmount": { pt: "Valor", en: "Amount" },
    "revenueReceived": { pt: "Recebido", en: "Received" },
    "revenueNote": { pt: "Nota", en: "Note" },
    "revenueNotePlaceholder": { pt: "Nota...", en: "Note..." },
    "revenueNoJobs": { pt: "Nenhum job agendado para este período", en: "No jobs scheduled for this period" },
    "revenueBankPayment": { pt: "Pagamento em Conta", en: "Bank Account Payment" },
    "revenueCashPayment": { pt: "Pagamento em Dinheiro", en: "Cash Payment" },
    "revenueBankSubtotal": { pt: "Subtotal Conta:", en: "Bank Account Subtotal:" },
    "revenueCashSubtotal": { pt: "Subtotal Cash:", en: "Cash Subtotal:" },
    "revenueGrandTotal": { pt: "TOTAL GERAL:", en: "GRAND TOTAL:" },
    "revenueErrorLoading": { pt: "Erro ao carregar dados", en: "Error loading data" },
    "revenueErrorSaving": { pt: "Erro ao salvar dados de pagamento", en: "Error saving payment data" },

    // Profit Analysis Page
    "profitTitle": { pt: "Análise de Lucro por Cliente", en: "Profit Analysis by Client" },
    "profitLaborConfig": { pt: "Configuração de Custo de Mão de Obra", en: "Labor Cost Configuration" },
    "profitLaborConfigDesc": { pt: "Defina o custo por hora de mão de obra para calcular as margens de lucro", en: "Set the hourly labor cost to calculate profit margins" },
    "profitCostPerHour": { pt: "Custo por Hora ($)", en: "Cost per Hour ($)" },
    "profitTotalRevenue": { pt: "Faturamento Total", en: "Total Revenue" },
    "profitTotalLaborCost": { pt: "Custo Total de Mão de Obra", en: "Total Labor Cost" },
    "profitTotalProfit": { pt: "Lucro Total", en: "Total Profit" },
    "profitAvgProfitHour": { pt: "Lucro Médio/Hora", en: "Avg Profit/Hour" },
    "profitDetailedAnalysis": { pt: "Análise Detalhada de Lucro", en: "Detailed Profit Analysis" },
    "profitClient": { pt: "Cliente", en: "Client" },
    "profitHours": { pt: "Horas", en: "Hours" },
    "profitInvoiceAmount": { pt: "Valor Invoice", en: "Invoice Amount" },
    "profitRevenueHour": { pt: "Faturamento/Hora", en: "Revenue/Hour" },
    "profitLaborCost": { pt: "Custo Mão de Obra", en: "Labor Cost" },
    "profitProfitCol": { pt: "Lucro Total", en: "Total Profit" },
    "profitProfitHour": { pt: "Lucro/Hora", en: "Profit/Hour" },
    "profitMargin": { pt: "Margem %", en: "Margin %" },
    "profitNoClients": { pt: "Nenhum cliente com valor de invoice configurado", en: "No clients with invoice amounts configured" },
    "profitInsights": { pt: "Insights", en: "Insights" },
    "profitMostProfitable": { pt: "Cliente Mais Lucrativo:", en: "Most Profitable Client:" },
    "profitBestProfitHour": { pt: "Melhor Lucro/Hora:", en: "Best Profit/Hour:" },
    "profitUnprofitable": { pt: "Clientes Não Lucrativos:", en: "Unprofitable Clients:" },
    "profitOverallMargin": { pt: "Margem Geral:", en: "Overall Margin:" },

    // Email Marketing Page
    "emailTitle": { pt: "Email Marketing", en: "Email Marketing" },
    "emailSubtitle": { pt: "Envie emails para todos os seus clientes", en: "Send emails to all your clients" },
    "emailClientsWithEmail": { pt: "clientes com email", en: "clients with email" },
    "emailCampaignComplete": { pt: "Campanha de email concluída!", en: "Email campaign completed!" },
    "emailSentFailed": { pt: "{sent} enviados, {failed} falharam de {total} clientes", en: "{sent} sent, {failed} failed out of {total} clients" },
    "emailRetryFailed": { pt: "Reenviar {count} emails que falharam", en: "Retry {count} failed emails" },
    "emailRetryWait": { pt: "(Aguarde alguns minutos antes de reenviar)", en: "(Wait a few minutes before retrying)" },
    "emailViewErrors": { pt: "Ver erros", en: "View errors" },
    "emailCompose": { pt: "Escrever Email", en: "Compose Email" },
    "emailSubject": { pt: "Assunto", en: "Subject" },
    "emailSubjectPlaceholder": { pt: "Assunto do email...", en: "Email subject..." },
    "emailContent": { pt: "Conteúdo", en: "Content" },
    "emailContentPlaceholder": { pt: "Escreva o conteúdo do email aqui...\n\nUse {nome} para incluir o primeiro nome do cliente.", en: "Write your email content here...\n\nUse {nome} to include the client's first name." },
    "emailContentTip": { pt: "Dica: Use {nome} e será substituído pelo primeiro nome de cada cliente", en: "Tip: Use {nome} and it will be replaced with each client's first name" },
    "emailPreview": { pt: "Visualizar", en: "Preview" },
    "emailTestAddress": { pt: "Email para teste", en: "Test email address" },
    "emailSendingProgress": { pt: "Enviando emails...", en: "Sending emails..." },
    "emailSendToClients": { pt: "Enviar para {count} clientes", en: "Send to {count} clients" },
    "emailRecipients": { pt: "Destinatários", en: "Recipients" },
    "emailNoClients": { pt: "Nenhum cliente com email válido", en: "No clients with valid email" },
    "emailPreviewTitle": { pt: "Visualização do Email", en: "Email Preview" },
    "emailPreviewNote": { pt: "Visualização usando nome de exemplo 'João'", en: "Preview using example name 'João'" },
    "emailConfirmTitle": { pt: "Confirmar Envio", en: "Confirm Send" },
    "emailConfirmMsg": { pt: "Tem certeza que deseja enviar este email para {count} clientes?", en: "Are you sure you want to send this email to {count} clients?" },
    "emailConfirmSubject": { pt: "Assunto:", en: "Subject:" },
    "emailConfirmContent": { pt: "Prévia do conteúdo:", en: "Content preview:" },
    "emailConfirmWarning": { pt: "Esta ação não pode ser desfeita. Recomendamos enviar um email de teste primeiro.", en: "This action cannot be undone. We recommend sending a test email first." },
    "emailConfirmSend": { pt: "Sim, enviar para {count} clientes", en: "Yes, send to {count} clients" },
    "emailFillSubjectContent": { pt: "Por favor preencha assunto e conteúdo", en: "Please fill in subject and content" },
    "emailFillTestEmail": { pt: "Por favor digite um email de teste", en: "Please enter a test email address" },
    "emailTestSent": { pt: "Email de teste enviado para {email}", en: "Test email sent to {email}" },
    "emailAccessDenied": { pt: "Acesso Negado", en: "Access Denied" },
    "emailAccessDeniedDesc": { pt: "Apenas administradores podem acessar esta página.", en: "Only administrators can access this page." },

    // Sync Xero Page
    "syncTitle": { pt: "Sincronização com Xero", en: "Xero Synchronization" },
    "syncDesc": { pt: "Conecte seus clientes do app com os contatos do Xero para habilitar o envio automático de invoices.", en: "Connect your app clients with Xero contacts to enable automatic invoice sending." },
    "syncConnect": { pt: "Conectar ao Xero", en: "Connect to Xero" },
    "syncConnecting": { pt: "Conectando...", en: "Connecting..." },
    "syncConnectDesc": { pt: "Primeiro, você precisa conectar sua conta do Xero para buscar seus contatos.", en: "First, you need to connect your Xero account to fetch your contacts." },
    "syncProgress": { pt: "Progresso da Sincronização", en: "Sync Progress" },
    "syncTokenTip": { pt: "Os tokens do Xero expiram a cada 30 minutos. Se tiver erro ao sincronizar, reconecte clicando no botão ao lado.", en: "Xero tokens expire every 30 minutes. If there's a sync error, reconnect by clicking the button." },
    "syncReconnect": { pt: "Reconectar Xero", en: "Reconnect Xero" },
    "syncHowItWorks": { pt: "Como funciona:", en: "How it works:" },
    "syncHowStep1": { pt: "Revise cada cliente do seu app e selecione o contato correspondente no Xero", en: "Review each app client and select the matching Xero contact" },
    "syncHowStep2": { pt: "Use o campo de pesquisa em cada cliente para encontrar o contato correto no Xero", en: "Use the search field for each client to find the correct Xero contact" },
    "syncHowStep3": { pt: "Os dados (email, telefone, invoice) serão importados do Xero", en: "Data (email, phone, invoice) will be imported from Xero" },
    "syncHowStep4": { pt: "O método de pagamento será automaticamente definido como \"Xero\"", en: "Payment method will be automatically set to \"Xero\"" },
    "syncHowStep5": { pt: "Clientes já sincronizados aparecem com badge verde", en: "Already synced clients show a green badge" },
    "syncSynced": { pt: "Sincronizado", en: "Synced" },
    "syncAlreadySynced": { pt: "Cliente já sincronizado com Xero", en: "Client already synced with Xero" },
    "syncUpdateData": { pt: "Atualizar Dados", en: "Update Data" },
    "syncNoSuggestion": { pt: "Nenhuma sugestão automática - use a pesquisa", en: "No automatic suggestions - use search" },
    "syncSuggestions": { pt: "sugestão(ões)", en: "suggestion(s)" },
    "syncResultsFound": { pt: "resultado(s) encontrado(s) de {total} contatos", en: "result(s) found from {total} contacts" },
    "syncSearchPlaceholder": { pt: "Pesquisar em todos os contatos do Xero...", en: "Search all Xero contacts..." },
    "syncNoResults": { pt: "Nenhum resultado encontrado para \"{term}\". Tente outro termo de busca.", en: "No results found for \"{term}\". Try another search term." },
    "syncSearchHint": { pt: "Use o campo de pesquisa acima para encontrar o cliente correto no Xero.", en: "Use the search field above to find the correct client in Xero." },
    "syncBestMatch": { pt: "Melhor match", en: "Best match" },
    "syncSyncBtn": { pt: "Sincronizar", en: "Sync" },
    "syncSyncAllSelected": { pt: "Sincronizar Todos Selecionados", en: "Sync All Selected" },
    "syncSureMatches": { pt: "Tem certeza das correspondências? Você pode sincronizar todos de uma vez.", en: "Sure about the matches? You can sync them all at once." },
    "syncAccessDenied": { pt: "Acesso negado. Apenas administradores podem acessar esta página.", en: "Access denied. Only administrators can access this page." },
    "syncLoading": { pt: "Carregando...", en: "Loading..." },
    "syncXeroContactNotFound": { pt: "Contato do Xero não encontrado. Tente recarregar a página.", en: "Xero contact not found. Try reloading the page." },
    "syncSessionExpired": { pt: "Sessão do Xero expirou!", en: "Xero session expired!" },
    "syncErrorSync": { pt: "Erro ao sincronizar cliente:", en: "Error syncing client:" },
    "syncErrorConnect": { pt: "Erro ao conectar ao Xero:", en: "Error connecting to Xero:" },
    "syncTip": { pt: "Dica:", en: "Tip:" },

    // Tracking Page
    "trackingTitle": { pt: "Rastreamento de Funcionários", en: "Employee Tracking" },
    "trackingSubtitle": { pt: "Selecione um funcionário para visualizar detalhes de rastreamento", en: "Select an employee to view tracking details" },
    "trackingRefresh": { pt: "Atualizar", en: "Refresh" },
    "trackingLoadingData": { pt: "Carregando dados de rastreamento...", en: "Loading tracking data..." },
    "trackingNoData": { pt: "Nenhum rastreamento encontrado no sistema.", en: "No tracking found in the system." },
    "trackingEmployees": { pt: "Funcionários", en: "Employees" },
    "trackingTotalTrackings": { pt: "Total Rastreamentos", en: "Total Trackings" },
    "trackingTotalHours": { pt: "Horas Totais", en: "Total Hours" },
    "trackingStationary": { pt: "Parado Total", en: "Total Stationary" },
    "trackingTrackings": { pt: "rastreamento(s)", en: "tracking(s)" },
    "trackingLast": { pt: "Último:", en: "Last:" },
    "trackingTotal": { pt: "Total:", en: "Total:" },
    "trackingStopped": { pt: "Parado:", en: "Stationary:" },
    "trackingTravel": { pt: "Trajeto:", en: "Travel:" },
    "trackingViewDetails": { pt: "Ver Detalhes", en: "View Details" },

    // User Salary Settings
    "salarySettings": { pt: "Configuração de Salário", en: "Salary Settings" },
    "hourlyRate": { pt: "Taxa Hora ($/hr)", en: "Hourly Rate ($/hr)" },
    "deductionRate": { pt: "Dedução (%)", en: "Deduction (%)" },
    "viewProfile": { pt: "Ver Perfil", en: "View Profile" },
    "users": { pt: "usuários", en: "users" },
  };

  return translations[key]?.[language] || key;
};
